import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import Fade from '@mui/material/Fade';
import { Box } from '../../atoms/layout/box';
import { styled } from '@mui/material';

type DelayedLinearProgressProps = LinearProgressProps & {
  show?: boolean;
};
export function DelayedLinearProgress({ show = true, ...props }: DelayedLinearProgressProps) {
  // @TODO - move this value into theme
  const transitionDelayInMs = `600ms`;
  return (
    <Box height={0}>
      <Fade
        in={show}
        style={{
          transitionDelay: show ? transitionDelayInMs : '0ms',
        }}
      >
        <LinearProgressStyled {...props} />
      </Fade>
    </Box>
  );
}

const LinearProgressStyled = styled(LinearProgress)(({ theme }) => ({
  height: '1px',
}));
